import { render, staticRenderFns } from "./HeaderStatistics.vue?vue&type=template&id=53504af5&scoped=true&"
import script from "./HeaderStatistics.vue?vue&type=script&lang=js&"
export * from "./HeaderStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53504af5",
  null
  
)

export default component.exports